module.exports = __webpack_public_path__ + "img/Afdt-logo.7099b652.png";